
import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import VoteList from '../components/SyVoteList.vue';
import PickerInput from '../components/PickerInput.vue';
import SearchInput from '../components/SearchInput.vue';
import { getMajorList, getCollegeList } from '../api/index';
@Component({
  name: 'CollegeWork',
  components: {
    Banner,
    VoteList,
    PickerInput,
    SearchInput,
  },
})
export default class Detail extends Vue {
  collegeData: any = {};
  majorList: any[] = [];
  sortBy = 'vote-list';
  selectMajor = '';
  searchData = '';
  tempSearchData = '';

  get params() {
    this.banner();
    return this.$route.query;
  }

  async banner() {
    const ret = await getCollegeList();
    this.collegeData = ret.data;
    this.fetchMajorList();
    if (this.collegeData) {
      // const temp: any = JSON.parse(data);
      this.collegeData = this.collegeData.filter((item: any, index: number) => {
        return item.id === this.params.id;
      })[0];
    }
  }

  async fetchMajorList() {
    const ret = await getMajorList(this.params.id as string);
    this.majorList = ret.data.map((item: any) => item.title);
  }
  jumpDetail(item: any) {
    this.$router.push({
      path: 'WorkDetail',
      query: {
        id: item.id as string,
      },
    });
  }
  handleSearchData(e: any) {
    this.tempSearchData = e;
    console.log(e);
  }
  handleStartSearch() {
    console.log('start search!');
    // this.selectMajor = '';
    this.searchData = this.tempSearchData;
  }
  handClickSortBy() {
    this.sortBy = this.sortBy === 'vote-list' ? 'vote-list-rand' : 'vote-list';
  }
  pickerData(e: any) {
    console.log(e);
    this.selectMajor = e;
  }
  // 跳转院校详情
  toCollegeDetail() {
    window.location.href = this.collegeData.video;
  }
    // 跳转院校详情
  toCollegeHome() {
    this.$router.push('Home');
  }
  // 返回
  backRoute() {
    if (window.history.length <= 1) {
      this.$router.push('index');
    } else {
      this.$router.go(-1);
    }
  }
}
